// extracted by mini-css-extract-plugin
export default {"download":"download-hCpMAP","withWallet":"withWallet-XtjV0r","icon":"icon-t3SLsV","overlay":"overlay-lH0me0"};